import styled from '@emotion/styled';

import type { FC, ReactNode } from 'react';

type SuccessInfoItemProps = {
  icon: ReactNode;
  label: string;
  value: string;
  order?: number;
};

interface RowProps {
  order?: number;
}

export const Row = styled.div<RowProps>`
  display: grid;
  grid-template-columns: 120px 1fr;
  align-items: center;
  order: 1;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    order: ${(props) => props.order};
  }
`;
export const CellInfo = styled.div`
  text-align: left;
  font-size: 18px;
`;

export const CellFirst = styled.div`
  font-size: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

export const ConfirmationRow: FC<SuccessInfoItemProps> = ({ icon, label, value, order }) => {
  return (
    <Row order={order}>
      <CellFirst>
        <IconContainer>
          {icon}
          <span style={{ marginLeft: '8px' }}>{label}</span>
        </IconContainer>
      </CellFirst>
      <CellInfo>{value}</CellInfo>
    </Row>
  );
};
